import $api from "../../axios"
import {AppDispatch} from "../index"
import {managerSlice} from "../slices/managerSlice"

export const getManagers = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(managerSlice.actions.fetching())
    const response = await $api.get("manager/manager/index")
    dispatch(managerSlice.actions.fetchSuccess(response.data))
  } catch (e: any) {
    dispatch(managerSlice.actions.fetchError(e))
  }
}